import '../../../sass/alpha-modules/optional/_bs-modal.scss'

import AlphaModule from '../../abstracts/classes/alpha-module'
import Modal from 'bootstrap/js/src/modal'

export default class BsModal extends AlphaModule {
  getName() {
    return 'bsModal'
  }

  getModalClass() {
    return Modal
  }
}
